export default "__VITE_ASSET__Bn8y2hV7__"